import { render, staticRenderFns } from "./RestaurantBilings.vue?vue&type=template&id=f1bb0d7e&scoped=true"
import script from "./RestaurantBilings.vue?vue&type=script&lang=js"
export * from "./RestaurantBilings.vue?vue&type=script&lang=js"
import style0 from "./RestaurantBilings.vue?vue&type=style&index=0&id=f1bb0d7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bb0d7e",
  null
  
)

export default component.exports